import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { AritoActionButton } from '@/components/custom/arito';
import { FormMode } from '@/types/form';
/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
  },
  activeTab: string = 'info'
) => {
  const { onAdd, onEdit, onDelete, onCopy, handleClose } = handlers;

  if (formMode !== 'view') {
    return null;
  }

  switch (activeTab) {
    case 'info':
      return (
        <>
          <AritoActionButton title='Thêm' icon={PlusStroke} onClick={onAdd} variant='primary' />
          <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEdit} />
          <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDelete} variant='destructive' />
          <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopy} />
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} onClick={handleClose} variant='destructive' />
        </>
      );
    case 'history':
      return (
        <>
          <AritoActionButton
            title='Refresh'
            variant='secondary'
            icon={RefreshCircle1ClockwiseStroke}
            onClick={() => console.log('refresh')}
          />
          <AritoActionButton
            title='Cố định cột'
            variant='secondary'
            icon={SignPostLeftStroke}
            onClick={() => console.log('pin')}
          />
          <AritoActionButton title='Đóng' variant='secondary' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
    default:
      return (
        <>
          <AritoActionButton title='Lưu' icon={FloppyDisk1Stroke} type='submit' />
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
  }
};
